import styled from "styled-components";

export default styled.span`
  display: flex;
  align-items: center;

  top: 0;
  left: 0;
  width: fit-content;
  background-color: #ffffff;
  border: 1px solid #e3e9ed;
  z-index: 5;
  padding: 1rem 1rem 1rem 2.5rem;
  height: 41px;
  border-radius: 1rem;
  z-index: -1;
  color: #3f3f40;
  font-size: 1.4rem;
`;
